import { SIDEBAR_CLICKED } from "./types";

export const SidebarClicked = () => {
  return {
    type: SIDEBAR_CLICKED,
  };
};
